import React, { useState } from 'react';
import { chip } from '../time/styles';

// Shared components for the document pages.

const STATUS_STYLE = {
    ISSUED: { color: '#3b82f6', bg: 'rgba(59,130,246,0.12)' },
    AWAITING_SIGNATURE: { color: '#d97706', bg: 'rgba(217,119,6,0.12)' },
    SIGNED: { color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
    REVOKED: { color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
};

export const DocStatus = ({ doc, hrView }) => {
    const s = STATUS_STYLE[doc.status] || STATUS_STYLE.ISSUED;
    const label = hrView && doc.status === 'AWAITING_SIGNATURE' ? 'Awaiting signature' : doc.statusLabel;
    return <span data-status={doc.status} style={{ ...chip, color: s.color, background: s.bg, borderColor: s.color, fontSize: 12, fontWeight: 600 }}>{label}</span>;
};

/** "Expires 20 Oct 2026", flagged when within 30 days or past. */
export const Expiry = ({ date }) => {
    const [now] = useState(() => Date.now());
    if (!date) return null;
    const d = new Date(`${date}T00:00:00Z`);
    const days = Math.floor((d - now) / 86400000);
    const color = days < 0 ? '#ef4444' : days <= 30 ? '#d97706' : 'var(--text-muted)';
    const text = d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
    return <span style={{ color, fontSize: 13 }}>{days < 0 ? `Expired ${text}` : `Expires ${text}`}</span>;
};
